import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useQuery } from "@tanstack/react-query";

const CUSTOM_ANALYTICS_REPORT_REVISIONS_QUERY_KEY =
  "customAnalyticsReportRevisions";

export function getCustomAnalyticsReportRevisionsQueryKey(
  teamId: string,
  customReportId: string,
) {
  return [
    CUSTOM_ANALYTICS_REPORT_REVISIONS_QUERY_KEY,
    teamId,
    customReportId,
  ] as const;
}

export function getCustomAnalyticsReportRevisionsQueryInvalidationKey(
  teamId: string,
) {
  return [CUSTOM_ANALYTICS_REPORT_REVISIONS_QUERY_KEY, teamId] as const;
}

export function useCustomAnalyticsReportRevisionsQuery({
  customReportId,
  enabled = true,
}: {
  customReportId: string;
  enabled?: boolean;
}) {
  const team = useRequiredContext(TeamContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery({
    queryKey: getCustomAnalyticsReportRevisionsQueryKey(
      team._id,
      customReportId,
    ),
    queryFn: async () => {
      return await rpcClient.listCustomAnalyticsReportRevisions({
        id: customReportId,
      });
    },
    enabled,
    staleTime: 10 * 1000,
  });
}
